
<template>
  <main class="mx-4 lg:mx-40 py-14 md:py-28 lg:py-24">
    <div class="sm:block">
        <div class="lg:pr-4 space-y-4 text-base text-center w-full">
          
          <h2 class="text-primar-400 text-3xl leading-6 font-extrabold">
            Introducción al trading para principiantes
          </h2>
          <p class="text-black leading-7 font-normal lg:text-lg">
            Al seguir estas secciones y lecciones, los principiantes obtendrán una comprensión integral del comercio y estarán mejor preparados para comenzar su viaje de comercio e inversión.
          </p>
      </div>
      <div class="lg:pr-4 space-y-4 text-base text-center pt-8">
        <input
              type="text"
              class="
                w-96
                py-2
                px-4
                bg-transparent
                shadow
                border
                rounded-md
                font-light
                text-base text-gray-900
                placeholder-gray-500
                transition
                duration-200
                focus:outline-none focus:bg-white focus:border-gray-300
              "
              placeholder="Buscar en este curso"
              required
              @input="isTyping = true"
              v-model="searchInput"
            />
      </div>
      <!-- Container for demo purpose -->
<div class="container my-24 mx-auto md:px-6 xl:px-24">
  <!-- Section: Design Block -->
  <section class="py-6 px-6  border-2 rounded-lg">
    <div class="text-center">
      <h2 class="mb-6 pl-6 text-2xl leading-6">Sección 1: Comprensión de los mercados e instrumentos financieros</h2>
    </div>
    

    <div id="accordionFlushExample mt-4">
      <div
        class="rounded-none border border-t-0 border-l-0 border-r-0 border-neutral-200"
        v-for="(entry, index) in entries"
        :key="'accordion1_' + index"
      >
        <h2 class="mb-0" id="flush-headingOne">
          <button
            @click.prevent="toggleCollapse(index)"
            class="text-primar-400 text-lg group relative flex w-full items-center rounded-none border-0 py-4 px-5 text-left text-base font-bold transition [overflow-anchor:none] hover:z-[2] focus:z-[3] focus:outline-none [&:not([data-te-collapse-collapsed])]:text-primary [&:not([data-te-collapse-collapsed])]:[box-shadow:inset_0_-1px_0_rgba(229,231,235)] dark:[&:not([data-te-collapse-collapsed])]:text-primary-400"
            type="button" data-te-collapse-init data-te-target="#flush-collapseOne" aria-expanded="false"
            aria-controls="flush-collapseOne">
            {{ entry.title }}
            <span
              v-if="index in collapseState && collapseState[index].collapsed"
              class="ml-auto h-5 w-5 shrink-0 rotate-[-180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-[#8FAEE0] dark:group-[[data-te-collapse-collapsed]]:fill-[#eee]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
              </svg>
            </span>
            <span v-else class="ml-auto h-5 w-5 shrink-0 rotate-[-360deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-[#8FAEE0] dark:group-[[data-te-collapse-collapsed]]:fill-[#eee]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path>
              </svg>
            </span>
          </button>
        </h2>
        <div
          v-if="index in collapseState && collapseState[index].collapsed"
          id="flush-collapseOne" class="!visible border-0"
          aria-labelledby="flush-headingOne"
          >
          <div class="text-center">
            <span class="text-primar-400">{{ entry.subtitle }}</span>
          </div>
          <div class="py-4 px-5 text-black leading-7 font-normal lg:text-base" v-html="$options.filters.highlight(entry.text, searchInput)">
            {{ entry.text }}
          </div>
        </div>
      </div>


    </div>
  </section>
  <section class="py-6 px-6 border-2 rounded-lg mt-12">
    <div class="text-center">
      <h2 class="mb-6 pl-6 text-2xl leading-6">Sección 2: Órdenes comerciales básicas y gestión de riesgos</h2>
    </div>
    

    <div id="accordionFlushExample mt-4">
      <div
        class="rounded-none border border-t-0 border-l-0 border-r-0 border-neutral-200"
        v-for="(entry, index) in entriesTwo"
        :key="'accordion1_' + index"
      >
        <h2 class="mb-0" id="flush-headingOne">
          <button
            @click.prevent="toggleCollapseTwo(index)"
            class="text-primar-400 text-lg group relative flex w-full items-center rounded-none border-0 py-4 px-5 text-left text-base font-bold transition [overflow-anchor:none] hover:z-[2] focus:z-[3] focus:outline-none [&:not([data-te-collapse-collapsed])]:text-primary [&:not([data-te-collapse-collapsed])]:[box-shadow:inset_0_-1px_0_rgba(229,231,235)] dark:[&:not([data-te-collapse-collapsed])]:text-primary-400"
            type="button" data-te-collapse-init data-te-target="#flush-collapseOne" aria-expanded="false"
            aria-controls="flush-collapseOne">
            {{ entry.title }}
            <span
              v-if="index in collapseStateTwo && collapseStateTwo[index].collapsed"
              class="ml-auto h-5 w-5 shrink-0 rotate-[-180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-[#8FAEE0] dark:group-[[data-te-collapse-collapsed]]:fill-[#eee]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
              </svg>
            </span>
            <span v-else class="ml-auto h-5 w-5 shrink-0 rotate-[-360deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-[#8FAEE0] dark:group-[[data-te-collapse-collapsed]]:fill-[#eee]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path>
              </svg>
            </span>
          </button>
        </h2>
        <div
          v-if="index in collapseStateTwo && collapseStateTwo[index].collapsed"
          id="flush-collapseOne" class="!visible border-0"
          aria-labelledby="flush-headingOne"
          >
          <div class="text-center">
            <span class="text-primar-400">{{ entry.subtitle }}</span>
          </div>
          <div class="py-4 px-5 text-black leading-7 font-normal lg:text-base" v-html="entry.text">
            
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="py-6 px-6 border-2 rounded-lg mt-12">
    <div class="text-center">
      <h2 class="mb-6 pl-6 text-2xl leading-6">Sección 3: Análisis técnico</h2>
    </div>
    

    <div id="accordionFlushExample mt-4">
      <div
        class="rounded-none border border-t-0 border-l-0 border-r-0 border-neutral-200"
        v-for="(entry, index) in entriesTree"
        :key="'accordion1_' + index"
      >
        <h2 class="mb-0" id="flush-headingOne">
          <button
            @click.prevent="toggleCollapseTree(index)"
            class="text-primar-400 text-lg group relative flex w-full items-center rounded-none border-0 py-4 px-5 text-left text-base font-bold transition [overflow-anchor:none] hover:z-[2] focus:z-[3] focus:outline-none [&:not([data-te-collapse-collapsed])]:text-primary [&:not([data-te-collapse-collapsed])]:[box-shadow:inset_0_-1px_0_rgba(229,231,235)] dark:[&:not([data-te-collapse-collapsed])]:text-primary-400"
            type="button" data-te-collapse-init data-te-target="#flush-collapseOne" aria-expanded="false"
            aria-controls="flush-collapseOne">
            {{ entry.title }}
            <span
              v-if="index in collapseStateTree && collapseStateTree[index].collapsed"
              class="ml-auto h-5 w-5 shrink-0 rotate-[-180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-[#8FAEE0] dark:group-[[data-te-collapse-collapsed]]:fill-[#eee]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
              </svg>
            </span>
            <span v-else class="ml-auto h-5 w-5 shrink-0 rotate-[-360deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-[#8FAEE0] dark:group-[[data-te-collapse-collapsed]]:fill-[#eee]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path>
              </svg>
            </span>
          </button>
        </h2>
        <div
          v-if="index in collapseStateTree && collapseStateTree[index].collapsed"
          id="flush-collapseOne" class="!visible border-0"
          aria-labelledby="flush-headingOne"
          >
          <div class="text-center">
            <span class="text-primar-400">{{ entry.subtitle }}</span>
          </div>
          <div class="py-4 px-5 text-black leading-7 font-normal lg:text-base" v-html="entry.text">
            
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="py-6 px-6 border-2 rounded-lg mt-12">
    <div class="text-center">
      <h2 class="mb-6 pl-6 text-2xl leading-6">Sección 4: Análisis fundamental</h2>
    </div>
    

    <div id="accordionFlushExample mt-4">
      <div
        class="rounded-none border border-t-0 border-l-0 border-r-0 border-neutral-200"
        v-for="(entry, index) in entriesFour"
        :key="'accordion1_' + index"
      >
        <h2 class="mb-0" id="flush-headingOne">
          <button
            @click.prevent="toggleCollapseFour(index)"
            class="text-primar-400 text-lg group relative flex w-full items-center rounded-none border-0 py-4 px-5 text-left text-base font-bold transition [overflow-anchor:none] hover:z-[2] focus:z-[3] focus:outline-none [&:not([data-te-collapse-collapsed])]:text-primary [&:not([data-te-collapse-collapsed])]:[box-shadow:inset_0_-1px_0_rgba(229,231,235)] dark:[&:not([data-te-collapse-collapsed])]:text-primary-400"
            type="button" data-te-collapse-init data-te-target="#flush-collapseOne" aria-expanded="false"
            aria-controls="flush-collapseOne">
            {{ entry.title }}
            <span
              v-if="index in collapseStateFour && collapseStateFour[index].collapsed"
              class="ml-auto h-5 w-5 shrink-0 rotate-[-180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-[#8FAEE0] dark:group-[[data-te-collapse-collapsed]]:fill-[#eee]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
              </svg>
            </span>
            <span v-else class="ml-auto h-5 w-5 shrink-0 rotate-[-360deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-[#8FAEE0] dark:group-[[data-te-collapse-collapsed]]:fill-[#eee]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path>
              </svg>
            </span>
          </button>
        </h2>
        <div
          v-if="index in collapseStateFour && collapseStateFour[index].collapsed"
          id="flush-collapseOne" class="!visible border-0"
          aria-labelledby="flush-headingOne"
          >
          <div class="text-center">
            <span class="text-primar-400">{{ entry.subtitle }}</span>
          </div>
          <div class="py-4 px-5 text-black leading-7 font-normal lg:text-base" v-html="entry.text">
            
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="py-6 px-6 border-2 rounded-lg mt-12">
    <div class="text-center">
      <h2 class="mb-6 pl-6 text-2xl leading-6">Sección 5: Comercio de criptomonedas</h2>
    </div>
    

    <div id="accordionFlushExample mt-4">
      <div
        class="rounded-none border border-t-0 border-l-0 border-r-0 border-neutral-200"
        v-for="(entry, index) in entriesFive"
        :key="'accordion1_' + index"
      >
        <h2 class="mb-0" id="flush-headingOne">
          <button
            @click.prevent="toggleCollapseFive(index)"
            class="text-primar-400 text-lg group relative flex w-full items-center rounded-none border-0 py-4 px-5 text-left text-base font-bold transition [overflow-anchor:none] hover:z-[2] focus:z-[3] focus:outline-none [&:not([data-te-collapse-collapsed])]:text-primary [&:not([data-te-collapse-collapsed])]:[box-shadow:inset_0_-1px_0_rgba(229,231,235)] dark:[&:not([data-te-collapse-collapsed])]:text-primary-400"
            type="button" data-te-collapse-init data-te-target="#flush-collapseOne" aria-expanded="false"
            aria-controls="flush-collapseOne">
            {{ entry.title }}
            <span
              v-if="index in collapseStateFive && collapseStateFive[index].collapsed"
              class="ml-auto h-5 w-5 shrink-0 rotate-[-180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-[#8FAEE0] dark:group-[[data-te-collapse-collapsed]]:fill-[#eee]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
              </svg>
            </span>
            <span v-else class="ml-auto h-5 w-5 shrink-0 rotate-[-360deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-[#8FAEE0] dark:group-[[data-te-collapse-collapsed]]:fill-[#eee]">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path>
              </svg>
            </span>
          </button>
        </h2>
        <div
          v-if="index in collapseStateFive && collapseStateFive[index].collapsed"
          id="flush-collapseOne" class="!visible border-0"
          aria-labelledby="flush-headingOne"
          >
          <div class="text-center">
            <span class="text-primar-400">{{ entry.subtitle }}</span>
          </div>
          
          <div class="py-4 px-5 text-black leading-7 font-normal lg:text-base" v-html="entry.text">
            
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="lg:pr-4 space-y-4 text-base mt-32 w-full">
          
          <h2 class="text-primar-400 text-sm leading-6">
            * Recuerde que el comercio, especialmente en criptomonedas, puede ser muy volátil y riesgoso. Es fundamental contar con un plan de gestión de riesgos bien pensado y utilizar cuentas de demostración para adquirir experiencia y perfeccionar sus habilidades.
          </h2>
          <h2 class="text-primar-400 text-sm leading-6">
            * Nunca se apresure a realizar operaciones reales sin la preparación y la práctica adecuadas.
          </h2>
      </div>
  


  <!-- Section: Design Block -->
</div>
<!-- Container for demo purpose -->
    </div>
  </main>
</template>
<script>
import Vue from 'vue';
import _ from "lodash";
Vue.filter('highlight', function(word, query){
  if (!query) {
    return word.toString();
  }
  var check = new RegExp(query, "ig");
  return word.toString().replace(check, function(matchedText,a,b){
      return ('<strong style="background-color:yellow">' + matchedText + '</strong>');
  });
});
export default {
  components: {},
  created() {},
  data() {
    return {
      searchInput: '',
      collapseState: [],
      collapseStateTwo: [],
      collapseStateTree: [],
      collapseStateFour: [],
      collapseStateFive: [],
      entries: [{
        title: `Lección 1: Introducción a los mercados financieros`,
        text: `Mercados financieros: donde ocurre la magia del dinero
            <br><br>
            Los mercados financieros pueden compararse con mercados bulliciosos. Sin embargo en lugar de frutas, ropa o aparatos, es donde la gente compra y vende cosas relacionadas con el dinero. ¡Imagínelo como un lugar donde ocurre magia con el dinero!
            <br><br>Así es como funciona:<br>
            <br>
            1. La magia del mercado: Los mercados financieros son como grandes estadios o centros comerciales donde todos se reúnen para comerciar. Piense en ellos como espacios organizados donde la gente puede intercambiar cosas relacionadas con el dinero.
            <br><br>
            2. Secretos comerciales: Entonces, ¿por qué la gente va a estos mercados? Operan por varias razones y una de las principales es ganar dinero. Es como cuando compras un dispositivo genial en oferta y luego lo vendes por más dinero. En el mercado financiero, la gente intenta comprar cosas a un precio más bajo y venderlas cuando valen más. Así ganan dinero.
            <br><br>
            3. Diferentes tipos de cosas: Ahora, aquí es donde se pone emocionante. En estos mercados financieros, puede encontrar todo tipo de cosas para negociar. Hay secciones para acciones, divisas, materias primas (como oro y petróleo) e incluso índices que reflejan el comportamiento de ciertos sectores del mercado.
            <br><br>
            4. Historias de acciones: Hablemos de acciones por un momento. Cuando compras acciones, es como poseer una pequeña parte de una gran empresa. La gente negocia acciones porque cree que a estas empresas les irá bien en el futuro y, cuando lo hacen, las acciones se vuelven más valiosas.
            <br><br>
            5. Monedas y más: En otro rincón del mercado financiero, está el comercio de divisas. Aquí, la gente cambia el dinero de un país por otro, como cambiar dólares por euros antes de un viaje. Hacen esto porque creen que el valor del dinero cambiará y pueden obtener ganancias.
            <br><br>
            6. Apuestas con CFD: A veces, las personas en el mercado financiero hacen apuestas sobre cómo cambiarán las cosas sin poseerlas realmente. Para ello utilizan algo llamado Contratos por Diferencia (CFD). Es un poco como predecir qué equipo ganará un partido deportivo sin ser dueño del equipo.
            <br><br>
            Los mercados financieros son como mercados mágicos donde la gente se reúne para intercambiar cosas relacionadas con el dinero. Operan para ganar dinero comprando barato y vendiendo caro. Estos mercados tienen secciones para acciones, divisas, materias primas y más. ¡Es un lugar donde los sueños económicos de la gente se hacen realidad!
            Tipos de mercados financieros: su campo de operaciones
            <br><br>
Los mercados financieros son como un patio de recreo para adultos donde se pueden intercambiar diversos tipos de "juguetes" financieros. Exploremos tres de las partes más interesantes de este parque infantil:
<br><br>
1. Mercado de Valores: El Carnaval de la Empresa<br>
Piense en el mercado de valores como un carnaval lleno de puestos de empresas. Cada stand representa una empresa diferente. Cuando compras un boleto (una acción), puedes disfrutar de una pequeña porción de la diversión que está teniendo esa compañía. A la gente le encanta el mercado de valores porque puede invertir en empresas que creen que crecerán y generarán ganancias. A medida que la empresa prospera, el valor de su billete (acciones) aumenta y puede venderlo por más dinero.
<br><br>
2. Mercado Forex: El mercado mundial de divisas<br>
Imagine el mercado de divisas como un bullicioso aeropuerto internacional donde la gente cambia su moneda local por monedas extranjeras. Es como cambiar dólares por euros o yenes antes de viajar. La gente comercia en el mercado de divisas porque cree que una moneda será más valiosa en comparación con otra. Es un poco como predecir el tiempo, pero con dinero.
<br><br>
3. Mercado de materias primas: el tesoro escondido<br>
El mercado de materias primas es como un tesoro lleno de cosas valiosas como oro, petróleo, café y más. Estos artículos tienen usos en el mundo real, por lo que la gente los intercambia porque quiere comprar a un precio favorable y, eventualmente, vender al alza. Al igual que coleccionar juguetes raros o cromos, también recolectan e intercambian productos básicos.
<br><br>
Cada uno de estos mercados financieros es como un juego diferente en el patio de recreo:<br>
- En el mercado de valores se trata de invertir en empresas.<br>
- El mercado de divisas implica el comercio de divisas de diferentes países.<br>
- El mercado de materias primas es como una búsqueda del tesoro de recursos valiosos.<br>
<br><br>
Y recuerde, puede explorar estos mercados utilizando diferentes herramientas como acciones, pares de divisas y contratos por diferencia (CFD), que hacen que el campo de operaciones sea aún más emocionante.

<br><br>
Explorando diferentes tipos de intercambios
<br>
En el mundo del comercio y las finanzas, los intercambios son como los escenarios donde ocurre toda la acción. Hay varios tipos de intercambios, cada uno con sus características y ofertas únicas. Echemos un vistazo a algunos de ellos:
<br>
1. Bolsas de Valores: Los Showrooms de la Empresa<br>
Las bolsas de valores son como grandes salas de exposición donde las empresas exponen sus acciones para que el público las compre y venda. Algunas bolsas de valores conocidas incluyen la Bolsa de Valores de Nueva York (NYSE) y el Nasdaq. Las empresas cotizan sus acciones en estas bolsas para recaudar dinero y permitir que las personas se conviertan en propietarios parciales (accionistas) de sus negocios.
<br><br>


2. Mercado Forex: El centro de divisas<br>
El mercado de divisas es un poco diferente. Se parece más a una red global de bancos e instituciones financieras que a un lugar físico. Aquí se negocian divisas de todo el mundo las 24 horas del día, los 7 días de la semana. Es como si estuvieras cambiando tu dinero en un aeropuerto internacional muy concurrido, pero ocurre de forma electrónica. Los principales pares de divisas como EUR/USD o USD/JPY son destinos populares en este mercado.
<br><br>
3. Bolsas de productos básicos: Las subastas de recursos<br>
Para materias primas como el oro, el petróleo o incluso los productos agrícolas, existen bolsas especializadas. Aquí es donde la gente comercializa estos bienes físicos, pero a menudo el comercio también se realiza electrónicamente. Por ejemplo, la Bolsa Mercantil de Chicago (CME) es una bolsa de productos básicos muy conocida.
<br><br>
4. Intercambios de criptomonedas: La frontera digital<br>
En el mundo de las monedas digitales como Bitcoin y Ethereum, los intercambios de criptomonedas son los lugares a los que acudir. Estas son plataformas en línea donde puedes comprar, vender e intercambiar criptomonedas. Algunos populares incluyen Coinbase y Binance. Los intercambios de criptomonedas le permiten ingresar al apasionante mundo de los activos digitales.
<br><br>
5. Bolsas de futuros y opciones: Los centros de gestión de riesgos<br>
Estos intercambios son como centros de gestión de riesgos. Aquí, las personas pueden negociar contratos financieros conocidos como futuros y opciones. Estos contratos permiten a los comerciantes especular sobre los precios futuros de diversos activos, incluidos productos básicos, acciones y más. La Bolsa de Opciones de la Junta de Chicago (CBOE) y la Bolsa Mercantil de Chicago (CME) son ejemplos de bolsas de futuros y opciones.
<br><br>
6. Mercados extrabursátiles (OTC): Los negociadores personalizados<br>
No todas las operaciones se realizan en grandes bolsas públicas. Los mercados OTC son como salas privadas de negociación donde se llevan a cabo acuerdos personalizados. Es donde puede encontrar operaciones e instrumentos financieros únicos que no encajan perfectamente en las ofertas de intercambio estándar.
<br><br>
Cada tipo de intercambio tiene un propósito específico y atiende a diferentes tipos de activos y comerciantes. Piense en ellos como varios escenarios en el gran teatro de las finanzas, donde se desarrollan diferentes actos dependiendo de lo que le interese negociar.
            `

      },
      {
        title: 'Lección 2: Comercio de Forex y pares de divisas principales',
        text: `Comercio de Forex: Desbloqueando el mundo de las divisas<br>
        <br>
El comercio de divisas es como una búsqueda del tesoro global; pero en lugar de buscar oro, busca oportunidades en pares de divisas. Profundicemos en qué es el comercio de divisas y por qué es tan importante:
<br><br>
1. ¿Qué es el comercio de divisas?<br>
Forex, abreviatura de divisas, es el mercado financiero más grande del mundo. Es donde se compran y venden monedas de diferentes países. Imagínate que estás en un aeropuerto internacional, cambiando tus dólares por euros antes de un viaje. El comercio de divisas es un poco así, pero ocurre a gran escala y las 24 horas del día.
<br><br>
2. Pares de divisas: Los dúos dinámicos<br>
En Forex, no sólo se opera con una moneda a la vez; intercambias pares de ellos. Estos pares son como dúos dinámicos en el mundo de las divisas. El par más popular es el EUR/USD, que involucra el euro y el dólar estadounidense. Cuando opera con estos pares, está apostando a si una moneda se fortalecerá o debilitará en comparación con la otra.
<br><br>
3. Comercio 24 horas al día, 7 días a la semana: acción las 24 horas del día<br>
Una cosa destacable del comercio de divisas es que nunca duerme. Funciona las 24 horas del día, cinco días a la semana. Esto significa que puede operar con divisas casi en cualquier momento, lo que lo hace increíblemente accesible para personas de todo el mundo.
<br><br>

4. Importancia del comercio de divisas: ¿Por qué es importante?<br>
El comercio de divisas es importante por múltiples razones:<br>
- Economía global : Forex es el corazón de la economía global. Es donde naciones, empresas e individuos intercambian monedas para el comercio internacional, el turismo y la inversión.<br>
- Liquidez : El mercado de divisas es increíblemente líquido, lo que significa que puedes comprar o vender divisas con facilidad. Esta fluidez garantiza que normalmente pueda ingresar o salir de operaciones sin muchos problemas.<br>
- Accesibilidad: El comercio de divisas es una de las formas de comercio más accesibles. No necesitas una gran cantidad de dinero para empezar y puedes hacerlo online desde cualquier parte del mundo.<br>
- Diversas oportunidades: Con una amplia gama de pares de divisas y estrategias, Forex ofrece diversas oportunidades para los operadores. Ya sea que sea un operador a corto plazo que busca movimientos rápidos o un inversor a largo plazo, hay algo para todos.<br>
- Gestión de riesgos: Las empresas y los inversores suelen utilizar Forex para la gestión de riesgos. Por ejemplo, una empresa podría utilizar Forex para protegerse de fluctuaciones monetarias desfavorables.<br>
<br><br>
    • Divisas: Es el arte de cambiar una moneda por otra y hacer predicciones sobre sus cambios de valor. Es el mercado financiero más grande y accesible a nivel mundial, con un impacto significativo en la economía global. Ya sea tanto para un operador experimentado o  para uno que recién esté comenzando, Forex abre un mundo de posibilidades en el juego del cambio de divisas.


    <br><br>
Principales pares de divisas: Los dúos dinámicos de Forex<br>
<br><br>
En el mundo del comercio de divisas, los pares de divisas son las estrellas del espectáculo. Estas parejas son como dúos dinámicos y cada uno tiene sus propias características únicas. Conozcamos algunos de los principales pares de divisas y comprendamos qué los hace especiales:
<br>
1. EUR/USD (euro/dólar estadounidense)<br>
- La Superestrella: EUR/USD es el par de divisas más negociado del mundo. Es como la superestrella del escenario forex.<br>
- Elegancia europea y poder americano: El EUR representa el euro, la moneda de la eurozona (un grupo de países europeos), mientras que el USD representa el dólar estadounidense. Este par refleja las fortalezas económicas y las políticas de ambas regiones.<br>
- Liquidez en abundancia: El EUR/USD es increíblemente líquido, lo que significa que es fácil de comprar y vender, y a menudo tiene diferenciales más pequeños (la diferencia entre los precios de compra y venta).
<br><br>
2. USD/JPY (dólar estadounidense/yen japonés)<br>
- El par Samurai: USD/JPY es conocido por su estabilidad y a menudo se lo considera un par de divisas de refugio seguro.<br>
- USD vs. JPY: Este par compara el dólar estadounidense, que representa a los Estados Unidos, con el yen japonés. Japón es conocido por su fuerte industria manufacturera.<br>
- Indicador de riesgo: Los operadores suelen utilizar el USD/JPY como indicador de la salud económica mundial. Cuando los operadores están preocupados por la incertidumbre económica, tienden a comprar yenes, lo que hace caer el USD/JPY.
<br><br>
3. GBP/USD (libra esterlina/dólar estadounidense)<br>
- La danza libra-dólar: GBP/USD refleja la relación entre la libra esterlina (GBP) y el dólar estadounidense (USD).<br>
- Importancia histórica: Este par tiene una larga historia y está influenciado por los acontecimientos económicos y políticos tanto en el Reino Unido como en los EE. UU.<br>
- Volatilidad: El GBP/USD puede ser bastante volátil, con importantes oscilaciones de precios, especialmente durante eventos económicos importantes como el Brexit.
<br><br>
4. AUD/USD (Dólar australiano/Dólar estadounidense)<br>
- Down Under Delight: Este par involucra el dólar australiano (AUD) y el dólar estadounidense (USD).<br>
- Moneda de las materias primas: La economía australiana está estrechamente ligada a los precios de las materias primas (como el mineral de hierro), lo que hace que el AUD/USD responda a los cambios en estos mercados.<br>
- Tasas de Interés: Los movimientos en las tasas de interés por parte del Banco de la Reserva de Australia (RBA) y la Reserva Federal de Estados Unidos pueden influir en este par.
<br><br>
5. USD/CAD (dólar estadounidense/dólar canadiense)<br>
- The Loonie Link: USD/CAD involucra el dólar estadounidense (USD) y el dólar canadiense (CAD).<br>
- Influencia del petróleo: El dólar canadiense a menudo se ve influenciado por los precios del petróleo, ya que Canadá es un importante exportador de petróleo. Entonces, cuando los precios del petróleo suben, el CAD tiende a fortalecerse frente al USD.<br>
- Tasas de interés: al igual que otros pares de divisas, las políticas de tasas de interés del Banco de Canadá y la Reserva Federal pueden afectar al USD/CAD.
<br><br>
Estos principales pares de divisas son como los personajes principales de la historia del comercio de divisas. Cada uno tiene sus rasgos únicos y está influenciado por diversos factores económicos, políticos y globales. Como operador de Forex, comprender sus características es esencial para tomar decisiones comerciales informadas.`
      },
      {
        title:'Lección 3: Acciones, materias primas e índices',
        subtitle:'Acciones: Propiedad de acciones en empresas',
        text: `Las acciones son como certificados de propiedad en las empresas. Cuando posee una acción, posee una parte de esa empresa. Aquí está la versión rápida:<br><br>
- ¿Qué son las acciones?: Son acciones de una empresa, lo que te convierte en accionista.<br>
- Papel en el comercio: Las acciones son para inversión, crecimiento potencial, dividendos y comercio a corto plazo.<br>
- Tipos: Las acciones ordinarias ofrecen derechos de propiedad y de voto; Las acciones preferentes proporcionan dividendos pero un poder de voto limitado.
<br><br>
En términos simples, las acciones le permiten poseer parte de una empresa y se utilizan tanto para inversiones a largo plazo como para operaciones a corto plazo.
<br><br>
Materias primas: bienes valiosos del mundo real
<br><br>
Las materias primas son como bienes valiosos del mundo real con los que la gente comercia en los mercados financieros. Aquí está la verdad:
¿Qué son las materias primas? Las materias primas son cosas que usamos o consumimos, como el oro, el petróleo, el café o el trigo. Tienen valor intrínseco.
<br><br>
Ejemplos de productos básicos: Algunos ejemplos comunes incluyen:<br>
- Oro: A menudo visto como una reserva de valor y utilizado en joyería y electrónica.<br>
- Petróleo: Esencial para la energía y el transporte.<br>
- Café: Disfrutado en todo el mundo como una bebida popular.<br>
- Trigo: Un alimento básico en la elaboración de pan y productos alimenticios.<br>
<br>
Comercio de materias primas: Las personas comercian con materias primas porque creen que sus precios cambiarán. Por ejemplo, si creen que la demanda de petróleo aumentará, podrían comprar contratos petroleros y venderlos más tarde, cuando el precio suba.
<br><br>
Usos diversos: Los productos básicos son únicos porque tienen usos prácticos y valor financiero. Esto los hace importantes en la economía global.
<br><br>
En pocas palabras, las materias primas son bienes tangibles como el oro, el petróleo, el café y el trigo, que tienen un valor intrínseco y se comercializan en los mercados financieros debido a su importancia en el mundo real y su potencial de cambios de precios. 
<br><br>





Índices bursátiles: el pulso del mercado<br>
<br><br>
Los índices bursátiles son como los latidos del mundo financiero. Nos ayudan a comprender cómo le está yendo al mercado en general. Profundicemos en qué son y por qué son importantes:
<br><br>
¿Qué son los índices bursátiles? Son como cuadros de mando que rastrean el desempeño de un grupo de acciones. En lugar de mirar acciones individuales, podemos ver cómo le está yendo a todo el mercado o sectores específicos al verificar estos índices.
Ejemplos: <br>
    • Un índice famoso es el S&P 500, que representa a 500 grandes empresas de Estados Unidos.<br>
    <br>
    • Otro es el Dow Jones Industrial Average (DJIA), que sigue a 30 importantes empresas estadounidenses.<br>
    <br>
Los índices bursátiles son cruciales porque nos dan una instantánea de la salud del mercado. Cuando un índice como el S&P 500 sube, generalmente significa que al mercado de valores le está yendo bien. Cuando baja, puede ser una señal de problemas.<br>
Los índices son diversos y cubren diversas industrias y sectores. Esta diversidad los convierte en indicadores confiables de la dirección general del mercado.
<br><br>
Inversión: Muchos inversores utilizan fondos indexados o fondos cotizados en bolsa (ETF) que reflejan estos índices. Es una forma de invertir en una amplia gama de acciones sin comprar cada una individualmente.
<br><br>
En pocas palabras, los índices bursátiles son como indicadores de salud del mercado. Nos ayudan a realizar un seguimiento del rendimiento de grupos de acciones, lo que las convierte en herramientas esenciales para los inversores y en un factor clave para comprender las tendencias y movimientos del mercado.
<br><br>



Contratos por diferencia (CFD): negociación sin propiedad
<br><br>
Los contratos por diferencia (CFD) son como una herramienta única en el mundo del trading, que le permite negociar activos sin poseerlos realmente. Así es como funcionan los CFD y cómo se pueden utilizar para operar con diversos activos:
<br>
1. ¿Qué son los CFD?<br>
- Los CFD son contratos financieros que le permiten especular sobre los movimientos de precios de activos, como acciones, divisas, materias primas e índices, sin poseer el activo subyacente en sí.<br>
- En lugar de comprar el activo real, usted celebra un contrato con un corredor para intercambiar la diferencia en el valor del activo entre el momento en que abre y cierra la operación.
<br><br>
2. Uso de CFD para negociar activos:<br>
- Acciones: Con los CFD, puede operar con acciones especulando si su precio aumentará (en posición larga) o bajará (en posición corta). Esto significa que potencialmente puedes beneficiarte de los movimientos de acciones sin poseerlas.<br>
- Divisas: En el comercio de divisas, los CFD se utilizan habitualmente para negociar pares de divisas. Puede celebrar contratos de CFD basándose en su creencia de que una moneda se fortalecerá frente a otra.<br>
- Materias primas: Los CFD le permiten operar con materias primas como oro, petróleo o trigo sin poseerlas físicamente. Puede beneficiarse de los cambios de precios sin necesidad de almacenamiento o entrega.<br>
- Índices: Operar con CFD sobre índices bursátiles como el S&P 500 le permite tomar una posición sobre el rendimiento general de un mercado sin comprar todas las acciones individuales.
<br><br>
3. Ventajas de los CFD:<br>
- Apalancamiento: Los CFD suelen ofrecer apalancamiento, lo que le permite controlar una posición más sustancial con una cantidad de capital relativamente pequeña. Sin embargo, esto puede amplificar tanto las ganancias como las pérdidas, por lo que es esencial utilizarlo con prudencia.<br>
- Venta en corto: Los CFD facilitan beneficiarse de la caída de los precios al ponerse en corto, lo que básicamente consiste en apostar a la caída del valor de un activo.<br>
- Mercados diversos: Los CFD brindan acceso a una amplia gama de mercados, lo que brinda a los operadores flexibilidad para diversificar sus carteras.<br>
<br>
4. Consideraciones de riesgo:<br>
Si bien los CFD ofrecen potencial para obtener mayores rendimientos debido al apalancamiento, también implican mayores riesgos. Las pérdidas pueden exceder su inversión inicial, por lo que la gestión de riesgos es crucial.<br>
<br>
Los CFD son instrumentos financieros versátiles que permiten a los operadores especular sobre los movimientos de precios de diversos activos, incluidas acciones, divisas, materias primas e índices, sin poseer los activos subyacentes. Ofrecen oportunidades de obtener ganancias, pero también conllevan un mayor riesgo debido al apalancamiento, por lo que los operadores deben utilizarlos con cuidado y considerar su tolerancia al riesgo.`
      }
    ],
    entriesTwo: [{
        title: `Lección 4: Órdenes comerciales básicas`,
        text: `Las órdenes comerciales son como instrucciones para el mercado, diciéndole lo que desea hacer con un activo en particular. Aquí hay tres órdenes comerciales fundamentales que debe comprender:
        <br><br>
1. Orden de compra:<br>
- Qué hace: una orden de compra es como decir: "Quiero comprar este activo al precio actual de mercado".<br>
- Cuándo usarlo: utilizaría una orden de compra cuando crea que el precio del activo aumentará y desee adquirirlo para beneficiarse del aumento potencial.
<br><br>
2. Orden de venta:<br>
- Qué hace: una orden de venta significa que desea vender un activo que ya posee, generalmente al precio de mercado actual.<br>
- Cuándo usarlo: utilizaría una orden de venta cuando crea que el precio del activo disminuirá y desea venderlo para evitar pérdidas potenciales o asegurar ganancias si ya lo posee.
<br><br>
3. Venta corta:<br>
- Qué hace: la venta en corto es lo opuesto a una orden de compra. Implica pedir prestado un activo que no es de su propiedad, venderlo al precio actual de mercado y esperar volver a comprarlo más tarde a un precio más bajo para devolvérselo al prestamista.<br>
- Cuándo usarlo: las ventas en corto se utilizan cuando se cree que el precio de un activo disminuirá. Es una forma de sacar provecho de la caída de los precios.
<br><br>
En pocas palabras, estas órdenes comerciales son sus herramientas para navegar por los mercados financieros:<br>
- Comprar: Adquirir un activo cuando se espera que su precio suba.<br>
- Vender: Enajenar un activo, ya sea para asegurar ganancias o evitar pérdidas cuando se espera que su precio baje.<br>
- Venta en corto: para beneficiarse de la caída del precio de un activo tomándolo prestado y vendiéndolo, y luego comprándolo de nuevo a un precio más bajo.<br>
Comprender y utilizar estas órdenes de forma eficaz es esencial para una negociación exitosa.<br><br>


Órdenes de obtención de beneficios y stop-loss: protegiendo sus operaciones<br><br>

Las órdenes “Take Profit” y “Stop Loss” son como su red de seguridad comercial. Le ayudan a gestionar el riesgo y asegurar las ganancias. Exploremos estas herramientas comerciales esenciales:<br>
1. Orden de obtención de beneficios:<br>
- ¿Qué hace?: Una orden Take Profit es como establecer un objetivo para su operación. Vende automáticamente un activo cuando alcanza un precio específico, asegurando sus ganancias.<br>
- ¿Por qué es importante?: Evita que te vuelvas demasiado codicioso y ayuda a garantizar que no pierdas ganancias potenciales al vender demasiado pronto.
<br><br>
2. Orden Stop Loss:<br>
- ¿Qué hace?: una orden Stop-Loss es su mecanismo de seguridad. Vende automáticamente un activo cuando su precio alcanza un cierto nivel que usted ha predefinido. Esto limita sus pérdidas potenciales.<br>
- ¿Por qué es importante?: Le protege de pérdidas significativas en caso de que el mercado se mueva en contra de su operación. Es como una salida de emergencia.<br>
<br>
Cuándo usarlos:<br>
- Take Profit: Úselo cuando tenga un objetivo de ganancias específico en mente. Por ejemplo, si compra una acción a $50 y cree que alcanzará los $60, puede establecer una orden Take Profit a $60 para asegurar esa ganancia.<br>
- Stop-Loss: Úselo para limitar sus pérdidas potenciales. Por ejemplo, si compra una acción a $50  dólares, pero no quiere perder más de $5 dólares por acción, puede establecer una orden Stop Loss a $45 dólares.
<br><br>
En resumen, las órdenes Take Profit y Stop-Loss son como sus guardaespaldas comerciales. Le ayudan a cumplir sus objetivos de ganancias y le protegen de pérdidas excesivas. El uso inteligente de estas órdenes es una parte clave de la gestión de riesgos en el comercio.<br>
<br>

Órdenes limitadas de venta y de compra: precisión comercial<br><br>

- Limitar venta: Establezca un objetivo para vender un activo a un precio específico o mejor cuando espere que su valor aumente.<br>
- Limitar compra: Especifique el precio al que desea comprar un activo, buscando una mejor oferta cuando crea que su precio bajará.<br>
Estas órdenes añaden precisión a sus operaciones y le ayudan a entrar y salir a los precios correctos.<br>
<br><br>
Trailing Stop-Loss y Take Profit: Gestión dinámica de riesgos
<br><br>
- Trailing Stop-Loss: Ajusta automáticamente su stop-loss a medida que el precio del activo se mueve a su favor para limitar pérdidas potenciales.<br>
- Take Profit final: Aumenta automáticamente su objetivo de ganancias a medida que aumenta el precio del activo, asegurando ganancias sin ajustes manuales.`
    },
  {
    title: `Lección 5: Lotes, Apalancamiento, Margen y Gestión de Riesgos`,
    subtitle: `Lotes de Forex: Gestión del tamaño de las operaciones`,
      text: `Los lotes de Forex son como las unidades que utiliza para medir y controlar el tamaño de su operación en el mercado de divisas. Aquí tienes una explicación clara de qué son y cómo calcularlos:
      <br><br>
¿Qué son los lotes de Forex? 
<br><br>
Un lote es una medida estandarizada que se utiliza en el comercio de divisas para especificar el volumen o tamaño de una operación. Determina qué cantidad de un par de divisas estás comprando o vendiendo.
<br><br>
Tipos de Lotes: Existen tres tipos principales de lotes:<br>
- Lote Estándar: 100.000 unidades de la moneda base.<br>
- Mini Lote: 10.000 unidades de la moneda base.<br>
- Micro Lote: 1.000 unidades de la moneda base.
<br><br>
Calcular el tamaño del lote: Para calcular el tamaño del lote, debe considerar:<br>
- El tamaño de su cuenta comercial.<br>
- El porcentaje de su cuenta que está dispuesto a arriesgar en una operación.<br>
- La distancia (en pips) entre su punto de entrada y su nivel de stop-loss.
<br><br>
Aquí hay una fórmula simplificada para calcular el tamaño del lote:<br>
Tamaño del lote = (Tamaño de la cuenta x Porcentaje de riesgo) / (Stop-Loss en pips x Valor del pip por lote)
<br><br>
Al utilizar lotes, puede gestionar su riesgo y operar con el tamaño adecuado según el tamaño de su cuenta y su tolerancia al riesgo. Es un concepto crucial para el comercio de divisas responsable.
<br><br>
Apalancamiento en el comercio de CFD
<br><br>
El apalancamiento en el comercio de CFD significa pedir prestados fondos para ampliar su posición comercial. Para calcular el tamaño de la posición, divida su capital comercial por el índice de apalancamiento. Por ejemplo, con $10,000 y un apalancamiento de 10x, el tamaño de su posición es $10,000 / 10 = $1,000.
<br><br>
Margen
<br><br>
El margen en el comercio es la garantía que necesita depositar para abrir y mantener una posición apalancada. Garantiza que pueda cubrir pérdidas potenciales. Si sus pérdidas exceden el margen, puede enfrentar una llamada de margen o la liquidación de su posición.
<br>
Las llamadas de margen son advertencias de los corredores que ocurren cuando las pérdidas de un comerciante se acercan al margen depositado para cubrir sus posiciones. Sirven para proteger a los comerciantes evitando que sus cuentas entren en saldos negativos, lo que puede conducir a la ruina financiera. Cuando se emite una llamada de margen, los operadores deben depositar más fondos o cerrar posiciones para reducir el riesgo de mayores pérdidas. Esto ayuda a garantizar un comercio responsable y protege a los operadores de pérdidas excesivas más allá de su inversión inicial.`
  }],
  entriesTree: [{
        title: `Lección 6: Introducción al Análisis Técnico`,
        subtitle: '',
        text: `El análisis técnico es un aspecto fundamental de la negociación que implica analizar datos históricos del mercado, centrándose principalmente en el precio y el volumen de negociación. Los comerciantes utilizan este enfoque para obtener información sobre los posibles movimientos futuros de precios de los activos. La idea central detrás del análisis técnico es que los patrones y tendencias históricas de precios tienden a repetirse, lo que permite a los operadores hacer predicciones informadas sobre hacia dónde se dirigirá el precio de un activo. Esto contrasta con el análisis fundamental, que se basa en la evaluación de la salud financiera y los factores económicos de una empresa para determinar el valor de un activo.
        <br><br>
La importancia del análisis técnico en el comercio radica en su capacidad de proporcionar a los operadores herramientas valiosas para la toma de decisiones. Al examinar los gráficos de precios, los operadores pueden identificar patrones como cabeza y hombros, doble techo o banderas alcistas. Estos patrones pueden indicar posibles oportunidades de compra o venta. Además, los indicadores técnicos como los promedios móviles, el RSI (índice de fuerza relativa) y el MACD (convergencia y divergencia del promedio móvil) brindan información cuantitativa sobre el impulso de un activo y sus posibles puntos de reversión. Los operadores utilizan estas herramientas para gestionar el riesgo, cronometrar sus operaciones y mejorar sus estrategias comerciales generales.
<br><br>
En resumen, el análisis técnico es un aspecto crucial del comercio porque brinda a los operadores la capacidad de analizar datos históricos y hacer predicciones informadas sobre futuros movimientos de precios. Al comprender los patrones de los gráficos y utilizar indicadores técnicos, los operadores pueden desarrollar estrategias efectivas, gestionar el riesgo y potencialmente aumentar sus posibilidades de éxito en los mercados financieros.`,
  },
{
  title: 'Lección 7: Indicadores técnicos comunes',
  text: `1. Medias móviles (MA): Las medias móviles suavizan los datos de precios para identificar tendencias. Dos tipos principales son la media móvil simple (SMA) y la media móvil exponencial (EMA). Ayudan a los operadores a detectar la dirección de la tendencia y posibles reversiones.
  <br>
2. Índice de fuerza relativa (RSI): El RSI mide la velocidad y el cambio de los movimientos de precios. Se utiliza para identificar condiciones de sobrecompra o sobreventa, lo que indica posibles cambios de tendencia.
<br>
3. Bandas de Bollinger: Las Bandas de Bollinger constan de una banda media (SMA) y dos bandas exteriores basadas en la volatilidad. Ayudan a identificar la volatilidad de los precios y posibles puntos de ruptura.
<br>
4. Convergencia y divergencia de media móvil (MACD): MACD combina dos EMA para mostrar la relación entre las tendencias de precios a corto y largo plazo. Ayuda a identificar cambios de tendencia y divergencias.
<br>
5. Oscilador estocástico: Este indicador mide el precio de cierre de un activo en relación con su rango de precios durante un período específico. Indica posibles puntos de reversión.
<br>
6. Retroceso de Fibonacci: Los niveles de Fibonacci se utilizan para identificar posibles niveles de soporte y resistencia basados en índices clave de Fibonacci. Los comerciantes los utilizan para predecir reversiones de precios.
<br>
7. Nube Ichimoku : Este indicador proporciona una visión completa del soporte, la resistencia y la dirección de la tendencia. Consta de cinco líneas y una nube, lo que ayuda a los operadores a tomar decisiones informadas.
<br>
8. Rango verdadero promedio (ATR): ATR mide la volatilidad del mercado analizando el rango entre los precios altos y bajos de un activo durante un período específico. Ayuda a establecer niveles de stop-loss.
<br>
9. SAR parabólico (detener y revertir): Los puntos SAR aparecen por encima o por debajo del precio, lo que indica posibles cambios de tendencia. Es útil para establecer órdenes de trailing stop.
<br>
10. Volumen: Si bien no es un indicador tradicional, el volumen de operaciones es esencial. Ayuda a confirmar las tendencias de los precios e identificar posibles rupturas o reversiones cuando se combina con otros indicadores.
<br><br>
Estos indicadores técnicos comunes son herramientas valiosas para que los operadores analicen movimientos de precios, detecten tendencias y tomen decisiones comerciales informadas. Los comerciantes suelen utilizar una combinación de estos indicadores para crear estrategias comerciales efectivas.`
},
{
  title: 'Lección 8: Estrategias comerciales simples',
  text: `1. Estrategia de cruce de media móvil:<br>
- Indicador: Medias Móviles Simples (SMA) con períodos de 50 y 200 días.<br>
- Estrategia: Comprar cuando la SMA de 50 días cruce por encima de la SMA de 200 días (cruz dorada) y vender cuando cruce por debajo (cruce de la muerte).<br>
- Ejemplo comercial: Si compró acciones de Apple Inc. (AAPL) Cuando la SMA de 50 días cruzó por encima de la SMA de 200 días en enero de 2020, habría ingresado a alrededor de $73 por acción. Al vender en septiembre de 2021, cuando se produjo el cruce inverso, podría haber salido a aproximadamente $149 por acción, lo que podría duplicar su inversión.
<br><br>
2. Estrategia de sobrecompra/sobreventa del RSI:<br>
- Indicador: Índice de Fuerza Relativa (RSI).<br>
- Estrategia: Comprar cuando el RSI cruce por debajo de $30 (sobreventa) y vender cuando cruce por encima de $70 (sobrecompra).<br>
- Ejemplo comercial: Si aplicó esta estrategia a Bitcoin (BTC) en marzo de 2020, cuando el RSI cayó por debajo de $30, podría haber comprado a alrededor de $6200 por BTC. Vender cuando el RSI cruzó por encima de $70 en diciembre de 2020 le habría permitido vender a aproximadamente $29,000 por BTC, lo que podría generar ganancias sustanciales.
<br><br>
3. Estrategia de ruptura de las Bandas de Bollinger:<br>
- Indicador: Bandas de Bollinger.<br>
- Estrategia: Comprar cuando el precio supere la banda de Bollinger superior y venda cuando supere la banda de Bollinger inferior.<br>
- Ejemplo comercial: Utilizando esta estrategia con acciones de Amazon (AMZN) en abril de 2020, cuando superaron la banda de Bollinger superior a aproximadamente $ 2,400 por acción, podría haber comprado. Vender cuando cayó por debajo de la Banda de Bollinger inferior en julio de 2020 a alrededor de $2.870 dólares por acción habría dado lugar a posibles beneficios.
<br><br>
Tenga en cuenta que estos ejemplos están simplificados con fines ilustrativos y no consideran los costos de transacción, los impuestos ni la volatilidad del mercado. El comercio real implica riesgos y el desempeño pasado no garantiza resultados futuros. Es esencial realizar una prueba retrospectiva y practicar minuciosamente cualquier estrategia antes de aplicarla en el comercio real.`
}
],
  entriesFour: [{
        title: `Lección 9: Introducción al análisis fundamental`,
        subtitle: '',
        text: `El análisis fundamental es un método para evaluar el valor intrínseco de un activo, como acciones, bonos o criptomonedas, mediante el examen de factores económicos y financieros subyacentes. Implica evaluar la salud financiera de una empresa, las condiciones de la industria, los indicadores económicos y otra información relevante para tomar decisiones de inversión informadas. El análisis fundamental es importante en el comercio porque ayuda a los operadores e inversores a comprender el verdadero valor de un activo, ya sea que esté sobrevaluado o infravalorado, y si tiene potencial de crecimiento o disminución a largo plazo. Al analizar estos fundamentos, los operadores pueden tomar decisiones más informadas sobre cuándo comprar o vender activos, lo que les ayuda a gestionar el riesgo y alcanzar sus objetivos financieros.`,
  },
  {
        title: `Lección 10: Principales acontecimientos económicos`,
        subtitle: '',
        text: `1. Nóminas no agrícolas (NFP): El informe NFP, publicado mensualmente en Estados Unidos, indica la cantidad de empleos agregados o perdidos en el mes anterior. Puede tener un impacto significativo en los mercados de divisas e influir en las decisiones sobre tipos de interés de los bancos centrales.<br>
2. Informes de ganancias: Cuando las empresas públicas publican sus informes de ganancias trimestrales o anuales, pueden producirse movimientos significativos en los precios de sus acciones. Las sorpresas positivas en las ganancias a menudo conducen a aumentos en el precio de las acciones.
<br>
3. Decisiones sobre tipos de interés: Los bancos centrales, como la Reserva Federal (Fed) de Estados Unidos, anuncian cambios en los tipos de interés. Las tasas más altas pueden fortalecer la moneda y afectar los mercados de acciones y bonos.
<br>
4. Producto Interno Bruto (PIB): Los informes del PIB brindan información sobre la salud económica de un país. Un PIB fuerte puede impulsar la confianza de los inversores, mientras que uno débil puede tener el efecto contrario.
<br>
5. Índice de Precios al Consumidor (IPC): El IPC mide la inflación. Un IPC superior a lo esperado puede generar preocupaciones sobre el aumento de precios y posibles cambios en las políticas del banco central.
<br>
6. Balanza comercial: Los informes de la balanza comercial revelan las exportaciones e importaciones de un país. Un superávit comercial (exportaciones > importaciones) puede fortalecer la moneda nacional.
<br>
7. Tasa de desempleo: La tasa de desempleo indica la salud del mercado laboral. Las tasas de desempleo más bajas pueden impulsar el gasto de los consumidores y la confianza.
<br>
8. Ventas minoristas: Las cifras de ventas minoristas reflejan el gasto de los consumidores, un componente crucial del crecimiento económico. Las fuertes ventas pueden ser positivas para la economía y los mercados.
<br>
9. Eventos políticos: Las elecciones, referendos o acontecimientos políticos importantes pueden provocar volatilidad en el mercado, ya que pueden afectar las políticas que afectan a las empresas y las industrias.
<br>
10. Desastres naturales: Eventos como huracanes, terremotos o pandemias pueden alterar las cadenas de suministro y afectar los mercados. Las acciones de seguros y relacionadas con desastres pueden experimentar una mayor actividad durante tales eventos.
<br><br>
Estos acontecimientos económicos tienen el potencial de mover los mercados significativamente, impactando los precios de los activos, el sentimiento de los inversores y las estrategias comerciales. Los comerciantes e inversores siguen de cerca estos eventos para tomar decisiones informadas y gestionar el riesgo de forma eficaz.`,
  },
  {
        title: `Lección 11: Estrategias de análisis fundamental`,
        subtitle: '',
        text: `1. Inversión de valor:<br>
- Estrategia: Identifique activos infravalorados mediante el análisis de estados financieros, informes de ganancias y relaciones como precio-beneficio (P/E) o precio-valor contable (P/B). Busque activos que coticen por debajo de su valor intrínseco.<br>
- Uso en Trading: Comprar activos infravalorados y conservarlos hasta que su precio de mercado se acerque a su valor intrínseco.
<br><br>
2. Inversión en crecimiento:<br>
- Estrategia: Centrarse en empresas con un gran potencial de crecimiento futuro mediante el análisis de las tasas de crecimiento de ingresos y ganancias, las tendencias del mercado y las ventajas competitivas.<br>
- Uso en el comercio: Compre acciones de empresas en crecimiento con perspectivas prometedoras de revalorización del capital a largo plazo.
<br><br>
3. Inversión de dividendos:<br>
- Estrategia: Invertir en empresas que paguen dividendos periódicamente. Analice el historial de dividendos, los índices de pago y la estabilidad financiera.<br>
- Uso en el comercio: Compre acciones que paguen dividendos para obtener ingresos o reinvertir, aprovechando los posibles aumentos de dividendos con el tiempo.
<br><br>

4. Inversión impulsada por eventos:<br>
- Estrategia: Capitalizar eventos específicos como fusiones, adquisiciones, anuncios de ganancias o cambios regulatorios analizando su impacto potencial en los precios de los activos.<br>
- Uso en el comercio: Opere basándose en las expectativas de cómo los eventos afectarán los valores de los activos. Por ejemplo, compre antes de un informe de ganancias positivo y venda después de uno negativo.
<br><br>
5. Análisis de sentimiento:<br>
- Estrategia: Evaluar el sentimiento del mercado mediante el análisis de noticias, redes sociales y encuestas para medir las emociones de los inversores y las expectativas de consenso.<br>
- Uso en el comercio: Los comerciantes contrarios pueden comprar cuando el sentimiento es excesivamente negativo y vender cuando es demasiado positivo.
<br><br>
En cuanto al calendario económico:
<br><br>
Un calendario económico es una herramienta que proporciona un cronograma de próximos eventos económicos, publicaciones de datos e informes. Aquí se explica cómo usarlo:
<br>
1. Acceda a un calendario económico: Utilice sitios web financieros, plataformas comerciales o aplicaciones para acceder a un calendario económico. Enumerará eventos, fechas, horas y el impacto esperado en los mercados.
<br>
2. Selección de eventos: Elija los eventos económicos que sean relevantes para su estrategia comercial. Por ejemplo, los operadores de divisas suelen centrarse en decisiones sobre tipos de interés, mientras que los operadores de acciones pueden observar los informes de ganancias.
<br>
3. Preparación: Revisar los detalles del evento y las expectativas del mercado. Esté atento a los pronósticos de consenso y los datos históricos para el contexto.
<br>
4. Estrategia comercial: Determine cómo operará durante el evento. Por ejemplo, si se espera que un banco central aumente las tasas de interés, considere el impacto potencial en los pares de divisas o los bonos.
<br>
5. Gestión de riesgos: Implemente una gestión de riesgos adecuada, incluido el establecimiento de órdenes de limitación de pérdidas, para proteger sus posiciones de movimientos inesperados del mercado.
<br>
6. Ejecución: Ejecute sus operaciones en función de su análisis y estrategia, ya sea antes, durante o después del evento, según su enfoque.
<br><br>
Un calendario económico ayuda a los operadores a mantenerse informados sobre eventos críticos que pueden afectar los mercados, permitiéndoles tomar decisiones comerciales oportunas y bien informadas.`,
  }
],
  entriesFive: [{
        title: `Lección 12: Introducción a las criptomonedas`,
        subtitle: '',
        text: `Las criptomonedas son monedas digitales o virtuales que utilizan criptografía por motivos de seguridad. Están descentralizadas y normalmente operan con una tecnología llamada blockchain, que es un libro de contabilidad distribuido que registra todas las transacciones en una red de computadoras. Las criptomonedas cumplen varias funciones en el mercado financiero:
        <br><br>
1. Moneda digital: Las criptomonedas se pueden utilizar como medio de intercambio de bienes y servicios, similar a las monedas fiduciarias tradicionales como el dólar estadounidense o el euro. Algunas criptomonedas tienen como objetivo proporcionar transacciones transfronterizas rápidas y de bajo costo.
<br>
2. Reserva de valor: Ciertas criptomonedas, como Bitcoin, a menudo se consideran oro digital o una reserva de valor. Los inversores pueden utilizarlos para protegerse contra la inflación o la inestabilidad económica.<br>
3. Inversión: Muchas personas e instituciones invierten en criptomonedas como activos especulativos, con la esperanza de que su valor aumente con el tiempo. Las criptomonedas han mostrado una importante volatilidad de precios, lo que puede presentar tanto riesgos como oportunidades para los inversores.
<br>
4. Tecnología Blockchain: Las criptomonedas están estrechamente vinculadas a la tecnología blockchain, que tiene aplicaciones más allá de la moneda. Blockchain se utiliza para la gestión de la cadena de suministro, sistemas de votación y más, lo que convierte a las criptomonedas en una puerta de entrada para explorar el potencial de blockchain.
<br>
5. Inclusión financiera: Las criptomonedas pueden brindar acceso a servicios financieros a personas en regiones con acceso limitado a los sistemas bancarios tradicionales. Las personas pueden enviar, recibir y almacenar valor sin depender de los bancos tradicionales.
<br>
6. Contratos inteligentes: Algunas criptomonedas, como Ethereum, admiten contratos inteligentes, que son contratos autoejecutables con los términos del acuerdo escritos directamente en código. Estos contratos automatizan y facilitan varios tipos de acuerdos y transacciones.
<br><br>
Las criptomonedas han llamado la atención por su potencial disruptivo en la industria financiera, al ofrecer nuevas formas de transferir valor, realizar negocios e invertir. Sin embargo, su naturaleza descentralizada, los desafíos regulatorios y la volatilidad de los precios también plantean riesgos y consideraciones únicos para quienes participan en el mercado de las criptomonedas.`,
  },
  {
        title: `Lección 13: Tecnología Blockchain`,
        subtitle: '',
        text: `La tecnología Blockchain es un sistema de contabilidad descentralizado y distribuido que registra transacciones en múltiples computadoras de una manera que garantiza transparencia, seguridad e inmutabilidad. Aquí hay una explicación de la tecnología blockchain y su importancia en las criptomonedas:
        <br><br>
1. Libro mayor distribuido: Blockchain es un libro de contabilidad digital que opera en una red descentralizada de computadoras, a menudo denominadas nodos. Cada nodo tiene una copia de toda la cadena de bloques, lo que garantiza que no haya un punto central de control o falla.
<br>
2. Bloques y transacciones: Las transacciones se agrupan en “bloques”. Estos bloques se vinculan en orden cronológico, formando una cadena de bloques, de ahí el nombre "blockchain". Cada bloque contiene un conjunto de transacciones, una marca de tiempo y una referencia al bloque anterior (excepto el primer bloque, conocido como "bloque génesis").
<br>
3. Transparencia e inmutabilidad: Una vez que se agrega una transacción a la cadena de bloques, se registra de forma transparente y no se puede modificar ni eliminar. Esta inmutabilidad garantiza la integridad del historial de transacciones, lo que lo hace altamente seguro contra manipulaciones.
<br>
4. Descentralización: Blockchain opera sin una autoridad central. Las transacciones son verificadas por los participantes de la red (nodos) a través de un mecanismo de consenso, como Prueba de trabajo ( PoW ) o Prueba de participación ( PoS ), lo que reduce la necesidad de intermediarios como los bancos.
<br>
5. Criptografía: La criptografía se utiliza para asegurar transacciones y controlar la creación de nuevas unidades de criptomonedas. Las claves públicas y privadas garantizan que solo los usuarios autorizados puedan acceder y realizar cambios en sus activos digitales.
<br>
6. Importancia de las criptomonedas: Blockchain es la tecnología subyacente de las criptomonedas como Bitcoin. Resuelve el problema del doble gasto, garantizando que los activos digitales no puedan duplicarse ni gastarse más de una vez. También permite transacciones entre pares sin confianza, eliminando la necesidad de intermediarios como los bancos en las transacciones financieras.
<br>
7. Transparencia y seguridad: Las características de transparencia y seguridad de Blockchain la hacen muy adecuada para registrar transacciones financieras de manera segura y transparente. Los usuarios pueden verificar de forma independiente las transacciones en blockchain, lo que reduce el riesgo de fraude.
<br>
8. Contratos inteligentes: Algunas plataformas blockchain, como Ethereum, admiten contratos inteligentes: contratos autoejecutables con reglas y condiciones predefinidas. Estos contratos automatizan acuerdos complejos, lo que permite una amplia gama de aplicaciones descentralizadas ( DApps ) más allá de las criptomonedas.
<br><br>
En resumen, la tecnología blockchain es la tecnología fundamental detrás de las criptomonedas. Su importancia radica en su capacidad de proporcionar una forma segura, transparente y descentralizada de registrar y verificar transacciones, lo que lo convierte en un punto de inflexión en el mundo de las finanzas y más allá. Tiene el potencial de revolucionar diversas industrias al proporcionar soluciones eficientes y a prueba de manipulaciones a problemas de larga data.`,
  },
  {
        title: `Lección 14: Las 10 principales criptomonedas`,
        subtitle: 'Presentamos las 10 principales criptomonedas por capitalización de mercado',
        text: `Estas son las 10 principales criptomonedas por capitalización de mercado según mi última actualización de conocimientos en septiembre de 2021. Tenga en cuenta que las clasificaciones y los valores pueden haber cambiado desde entonces, por lo que es una buena idea comprobar los datos más recientes:
        <br><br>
1. Bitcoin (BTC): A menudo llamado oro digital, es la primera y más conocida criptomoneda.
<br>
2. Ethereum (ETH): Conocido por sus capacidades de contratos inteligentes, es una plataforma para crear aplicaciones descentralizadas.
<br>
3. Binance Coin (BNB): Se utiliza en el intercambio de Binance , para tarifas comerciales y diversos servicios.
<br>
4. Cardano (ADA): Tiene como objetivo proporcionar una infraestructura segura y escalable para el desarrollo de aplicaciones descentralizadas.
<br>
5. Solana (SOL): Ganó popularidad por sus rápidas velocidades de transacción y bajas tarifas, y se utiliza para proyectos DeFi y NFT.
<br>
6. XRP (XRP): Desarrollado por Ripple, se enfoca en transferencias de dinero internacionales rápidas y de bajo costo.
<br>
7. Polkadot (DOT): Diseñado para conectar diferentes blockchains y permitirles trabajar juntas.<br>
8. Dogecoin (DOGE): Inicialmente comenzó como un meme, es una moneda digital que se utiliza para dar propinas y pequeñas transacciones.
<br>
9. USD Coin (USDC): Una moneda estable, su valor está vinculado al dólar estadounidense, lo que proporciona estabilidad para las transacciones.
<br>
10. Avalanche (AVAX): Una plataforma para crear y lanzar aplicaciones descentralizadas y cadenas de bloques personalizadas.
<br><br>
Recuerde que los mercados de criptomonedas son muy volátiles y las clasificaciones pueden cambiar rápidamente. Es esencial investigar y mantenerse actualizado sobre los últimos desarrollos si está considerando invertir en estas criptomonedas.`,
  },
  {
        title: `Lección 15: Comercio de criptomonedas con análisis técnico y CFD`,
        subtitle: 'Comercio de criptomonedas con análisis técnico:',
        text: `1. Comprensión del análisis técnico: El análisis técnico implica estudiar gráficos de precios históricos y utilizar varios indicadores para hacer predicciones sobre movimientos futuros de precios. Se supone que los datos pasados de precios y volúmenes pueden ayudar a pronosticar tendencias futuras.
        <br>
2. Seleccione una plataforma de negociación: Para comenzar, deberá elegir una plataforma de negociación de criptomonedas o un intercambio que ofrezca herramientas de análisis técnico. Muchos intercambios populares ofrecen gráficos e indicadores de forma gratuita.
<br>
3. Estudie los gráficos de velas japonesas: Los gráficos de velas japonesas muestran los movimientos de precios a lo largo del tiempo. Aprenda a leer estos gráficos, ya que muestran información clave como precios de apertura, cierre, máximos y mínimos para un período específico.
<br>
4. Utilice indicadores técnicos: Los analistas técnicos utilizan indicadores como medias móviles, índice de fuerza relativa (RSI) y bandas de Bollinger para identificar posibles puntos de entrada y salida. Estos indicadores pueden ayudarle a detectar tendencias, condiciones de sobrecompra o sobreventa, y más.
<br>
5. Identifique patrones: Busque patrones en los gráficos como cabeza y hombros, dobles techos/bajos y triángulos. Estos patrones pueden indicar posibles reversiones o continuaciones en las tendencias de precios.
<br>
6. Establezca puntos de entrada y salida: Según su análisis, decida cuándo comprar (entrada) y cuándo vender (salida) una criptomoneda. Esta decisión puede depender de indicadores, patrones o su tolerancia al riesgo.
<br>
7. Gestión de riesgos: Utilice siempre órdenes de límite de pérdidas para limitar las pérdidas potenciales. Determine cuánto está dispuesto a arriesgar en cada operación y cumpla con su plan.
<br>
8. Manténgase informado: Esté atento a las noticias y eventos que podrían afectar los mercados de criptomonedas. A veces las noticias pueden anular el análisis técnico, por lo que es esencial mantenerse informado.
<br><br>
Uso de CFD para el comercio de criptomonedas:
<br><br>
Los CFD (contratos por diferencia) son derivados financieros que permiten a los operadores especular sobre los movimientos de precios de las criptomonedas sin poseerlas realmente. Así es como funcionan:<br>
1. Operaciones apalancadas: Los CFD le permiten operar con apalancamiento, lo que significa que puede controlar una posición más sustancial con una cantidad menor de capital. Si bien esto puede amplificar las ganancias, también aumenta las pérdidas potenciales.
<br>
2. Sin propiedad: Con los CFD, usted no es propietario de la criptomoneda subyacente. En cambio, está celebrando un contrato con un corredor para beneficiarse de los cambios de precios.
<br>
3. Venta en corto: Los CFD le permiten beneficiarse de la caída de los precios de las criptomonedas vendiendo (en corto) antes de volver a comprar a un precio más bajo.
<br>
4. Gestión de riesgos: Al igual que el comercio tradicional, es fundamental gestionar el riesgo al operar con CFD. Utilice órdenes de limitación de pérdidas y órdenes de toma de ganancias para proteger su capital.
<br>
5. Regulación: El comercio de CFD está sujeto a regulación en muchos países. Asegúrese de operar con un corredor regulado y de buena reputación para proteger sus intereses.
<br><br>
Operar con criptomonedas con análisis técnico y utilizar CFD puede ser rentable, pero conlleva riesgos. Es recomendable comenzar con una cuenta demo para practicar sus habilidades y desarrollar una estrategia comercial antes de arriesgar dinero real. Además, invierta sólo lo que pueda permitirse perder, ya que los mercados de criptomonedas son muy volátiles.`,
  },
  {
        title: `Lección 16: Gestión y práctica de riesgos`,
        subtitle: 'Conclusión: preparándose para comenzar su viaje comercial',
        text: `La gestión de riesgos es un aspecto fundamental del trading y se recomienda encarecidamente practicar con cuentas de demostración. Profundicemos en por qué son esenciales:
<br><br>
Importancia de la gestión de riesgos en el comercio:
<br><br>
1. Preservar el capital: El objetivo principal de la gestión de riesgos es proteger su capital comercial. Al limitar las pérdidas potenciales, se asegura de tener fondos para operar otro día.
<br>
2. Control emocional: El trading puede ser un desafío emocional. Las estrategias de gestión de riesgos le ayudan a mantener la disciplina y reducir el impacto de emociones como el miedo y la codicia en sus decisiones.
<br>
3. Coherencia: Un plan de gestión de riesgos bien definido le mantiene coherente en su enfoque de negociación. Esta coherencia es crucial para el éxito a largo plazo.
<br>
4. Sobrevivir a las reducciones: Los mercados pueden ser impredecibles y todo el mundo experimenta pérdidas en sus operaciones. Una gestión de riesgos eficaz garantiza que pueda superar las rachas de pérdidas sin borrar su cuenta.
<br>
5. Tamaño de la posición: Le ayuda a determinar el tamaño correcto para cada operación en función de su tolerancia al riesgo. Esto evita que usted se sobreexponga a posibles pérdidas.
<br><br>
Fomentar la práctica con cuentas demo:
<br><br>
1. Entorno libre de riesgos: Las cuentas de demostración brindan una forma libre de riesgos de practicar estrategias comerciales y perfeccionar sus habilidades. Utiliza dinero virtual, por lo que no hay riesgo financiero.
<br>
2. Conozca la plataforma: Antes de operar en vivo, domine la plataforma de operaciones que desea utilizar. Las cuentas demo le permiten explorar sus características y funciones.
<br>
3. Pruebe estrategias: Pruebe diferentes estrategias comerciales e indicadores para ver cuál funciona mejor para usted. Esta experimentación puede ayudarle a encontrar una estrategia que se adapte a su estilo.
<br>
4. Generar confianza: Adquirir experiencia a través de la práctica genera confianza. Es mejor cometer errores en una cuenta demo que con dinero real.
<br>
5. Seguimiento del progreso: Utilice el comercio de demostración para realizar un seguimiento de su progreso y evaluar la eficacia de sus técnicas de gestión de riesgos.
<br>
6. Transición al comercio en vivo: Solo cuando logre consistentemente resultados positivos en una cuenta de demostración debería considerar la transición al comercio en vivo con dinero real.`,
  },
],
      isTyping: false
    };
  },
  watch: {
    'searchInput': _.debounce(function() {
      this.isTyping = false;
    }, 1000),
    isTyping: function(value) {
      if (!value) {
        this.search();
      }
    },
  },
  created() {
    
  },
  methods: {
    search() {
      if (!this.searchInput) {
        return;
      }
      this.collapseState = [];
      this.collapseStateTwo = [];
      this.collapseStateTree = [];
      this.collapseStateFour = [];
      this.collapseStateFive = [];

      let obj = this.entries.find((o, i) => {
          if (o.text.includes(this.searchInput)) {
              Vue.set(this.collapseState, i, {'collapsed': 1});
          }
      });

      let objTwo = this.entriesTwo.find((o, i) => {
          if (o.text.includes(this.searchInput)) {
              Vue.set(this.collapseStateTwo, i, {'collapsed': 1});
          }
      });

      let objTree = this.entriesTree.find((o, i) => {
          if (o.text.includes(this.searchInput)) {
              Vue.set(this.collapseStateTree, i, {'collapsed': 1});
          }
      });

      let objFour = this.entriesFour.find((o, i) => {
          if (o.text.includes(this.searchInput)) {
              Vue.set(this.collapseStateFour, i, {'collapsed': 1});
          }
      });

      let objFive = this.entriesFive.find((o, i) => {
          if (o.text.includes(this.searchInput)) {
              Vue.set(this.collapseStateFive, i, {'collapsed': 1});
          }
      });
      //console.log(obj);
    },
    toggleCollapse(index) {
      let find = 0;
      let findedElement = null;
      this.collapseState.forEach((element, indx) =>  {
        if (indx == index) {
          find = 1;
          findedElement = element;
        }
       });
      if(find == 0) {
        Vue.set(this.collapseState, index, {'collapsed': 1});
      } else {
        let aux = findedElement.collapsed;
        if (aux == 0) {
          aux = 1;
        } else {
          aux = 0;
        }
        Vue.set(this.collapseState[index], 'collapsed', aux);
      }
    },
    toggleCollapseTwo(index) {
      let find = 0;
      let findedElement = null;
      this.collapseStateTwo.forEach((element, indx) =>  {
        if (indx == index) {
          find = 1;
          findedElement = element;
        }
       });
      if(find == 0) {
        Vue.set(this.collapseStateTwo, index, {'collapsed': 1});
      } else {
        let aux = findedElement.collapsed;
        if (aux == 0) {
          aux = 1;
        } else {
          aux = 0;
        }
        Vue.set(this.collapseStateTwo[index], 'collapsed', aux);
      }
    },
    toggleCollapseTree(index) {
      let find = 0;
      let findedElement = null;
      this.collapseStateTree.forEach((element, indx) =>  {
        if (indx == index) {
          find = 1;
          findedElement = element;
        }
       });
      if(find == 0) {
        Vue.set(this.collapseStateTree, index, {'collapsed': 1});
      } else {
        let aux = findedElement.collapsed;
        if (aux == 0) {
          aux = 1;
        } else {
          aux = 0;
        }
        Vue.set(this.collapseStateTree[index], 'collapsed', aux);
      }
    },
    toggleCollapseFour(index) {
      let find = 0;
      let findedElement = null;
      this.collapseStateFour.forEach((element, indx) =>  {
        if (indx == index) {
          find = 1;
          findedElement = element;
        }
       });
      if(find == 0) {
        Vue.set(this.collapseStateFour, index, {'collapsed': 1});
      } else {
        let aux = findedElement.collapsed;
        if (aux == 0) {
          aux = 1;
        } else {
          aux = 0;
        }
        Vue.set(this.collapseStateFour[index], 'collapsed', aux);
      }
    },
    toggleCollapseFive(index) {
      let find = 0;
      let findedElement = null;
      this.collapseStateFive.forEach((element, indx) =>  {
        if (indx == index) {
          find = 1;
          findedElement = element;
        }
       });
      if(find == 0) {
        Vue.set(this.collapseStateFive, index, {'collapsed': 1});
      } else {
        let aux = findedElement.collapsed;
        if (aux == 0) {
          aux = 1;
        } else {
          aux = 0;
        }
        Vue.set(this.collapseStateFive[index], 'collapsed', aux);
      }
    },
  },
};
</script>